import template from './message.html';
import controller from './message.controller';
import './message.scss';

let messageComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '=',
    acl: '='
  },
  template,
  controller
};

export default messageComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/message.component.js